(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseSearchSort',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#cruisesearchsort-sort_by').change(function sortByChanged() {
			var asc_direction_label  = '',
				desc_direction_label = '';

			switch ($(this).val()) {
				case 'inside':
				case 'oceanview':
				case 'balcony':
				case 'suite':
					asc_direction_label  = 'Lowest';
					desc_direction_label = 'Highest';
				break;
				case 'trip_length':
					asc_direction_label  = 'Shortest';
					desc_direction_label = 'Longest';
				break;
				case 'cruise_line':
				case 'destination':
				case 'ship':
					asc_direction_label  = 'A to Z';
					desc_direction_label = 'Z to A';
				break;
				case 'sailing_date':
				case 'return_date':
				default:
					asc_direction_label  = 'Soonest';
					desc_direction_label = 'Furthest';
				break;
			}

			adjustText(asc_direction_label, desc_direction_label);
		});

		$('#cruisesearchsort-sort_by').trigger("change");
	};

	function adjustText(asc_direction_label, desc_direction_label) {
		$('#cruisesearchsort-direction > option').each(function changeText() {
			if (this.value === 'ASC') {
				this.text = asc_direction_label;
			}

			if (this.value === 'DESC') {
				this.text = desc_direction_label;
			}
		});
	}

}(jQuery, window.Adzuki || {}));